import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";
import { Z_INDEX } from "~/styles/z-index";

export const DivDmmMenuContainer = styled.div<{
  isTouchDevice: boolean;
  isOpen?: boolean;
}>`
  position: absolute;
  top: calc(${GLOBAL_NAVI_HEIGHT.PC}px - 5px);
  left: 3px;
  display: flex;
  background-color: ${COLOR.GRAY100.code};
  visibility: ${({ isTouchDevice, isOpen }) => (isTouchDevice ? (isOpen ? "visible" : "hidden") : "hidden")};
  opacity: ${({ isTouchDevice, isOpen }) => (isTouchDevice ? (isOpen ? 1 : 0) : "0")};
  box-shadow: 0 1px 2px 2px rgb(${COLOR.GRAY1000.rgb} / 20%);

  @media (any-hover: hover) {
    :hover {
      visibility: visible;
      opacity: 1;
      z-index: ${Z_INDEX.HEADER};
    }
  }
`;

export const ButtonIconWrapper = styled.button`
  vertical-align: bottom;
  margin: 3px 0 3px 3px;
  width: 51px;
  height: 42px;
  border: 1px ${COLOR.GRAY100.code} solid;
  border-right-color: ${COLOR.GRAY200.code};

  ${mq.sp} {
    padding: 0;
    margin: 0px;
  }

  div {
    justify-content: center;
  }

  div > svg {
    height: 42px;
    width: 42px;
  }
`;

export const DivContainer = styled.div`
  height: 100%;
  @media (any-hover: hover) {
    :hover {
      > button {
        position: relative;
        z-index: ${Z_INDEX.HEADER + 1};
        background-color: ${COLOR.GRAY100.code};
        border-color: ${COLOR.GRAY200.code};
        border-bottom-color: ${COLOR.GRAY100.code};
      }

      > div {
        visibility: visible;
        opacity: 1;
        z-index: ${Z_INDEX.HEADER};
        border: 1px ${COLOR.GRAY200.code} solid;
      }
    }
  }
`;
